import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Stats />
    </>
  );
};

export default HomePage;

